<script>

import { fromNowTimestamp } from '@/model/utils/utils'
import DetailOrder from '@/views/AadenPages/VipPage/DetailOrder.vue'
import { getAwardProgressByUserId } from '@/model/dataLayer/api/Vip/AwardType'
import { getAllVouchersForUserAndDevice } from '@/model/dataLayer/api/Vip/VoucherTypes'
import GlobalConfig from '@/model/global/GlobalSettings'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import { ageDisplay } from '@/model/dataLayer/api/Vip/UserDetail'

export default {
  name: 'UserDetailDialog',
  components: {
    LoadingProvider,
    DetailOrder
  },
  props: {
    info: {}
  },
  data () {
    return {
      loading: false,
      allVoucherRecord: [],
      progress: [],
      showDetailOrderInfoDialog: false,
      detailInfo: null,
      tab: null
    }
  },
  computed: {
    cloudUserDetail () {
      return this.info?.cloudUserInfo ?? {}
    },
    historyOrder () {
      return this.info?.orders ?? []
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    ageDisplay,
    async reload () {
      this.loading = true
      this.progress = await getAwardProgressByUserId(this.info.userId)
      this.allVoucherRecord = await getAllVouchersForUserAndDevice(this.info.userId, GlobalConfig.DeviceId)
      this.loading = false
    },
    fromNowTimestamp,
    showDetailOrderInfo (item) {
      this.detailInfo = JSON.parse(item.orderDetail.billDetail)
      this.showDetailOrderInfoDialog = true
    }

  }
}
</script>

<template>
  <div>
    <v-card
      class="pa-4 d-flex flex-column"
      color="#eeeeee"
      elevation="0"
    >
      <loading-provider :loading="loading">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <span class="text-caption">用户名</span>
            <span class="text-body-1 font-weight-bold">{{ info.cloudUserInfo.username }}</span>
          </div>
          <v-spacer />
          <div class="d-flex flex-column">
            <span class="text-caption">累计消费</span>
            <span class="text-body-1 font-weight-bold">{{ info.totalConsume }}</span>
          </div>
          <div class="d-flex flex-column ml-4">
            <span class="text-caption">入会门店名称</span>
            <span class="text-body-1 font-weight-bold">{{ info.memberOriginBlName }}</span>
          </div>
        </div>
        <div>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="black"
            style="background: transparent"
          >
            <v-tab>消费记录</v-tab>
            <v-tab>积分进度</v-tab>
            <v-tab>折扣码</v-tab>
          </v-tabs>
          <v-divider />
          <v-tabs-items
            v-model="tab"
            style="background: transparent"
          >
            <v-tab-item>
              <template v-if="historyOrder.length > 0">
                <div style="height: 50vh; overflow: scroll">
                  <v-card
                    v-for="(item,index) in historyOrder"
                    :key="index"
                    class="py-2 px-4 mt-2"
                    elevation="0"
                    @click="showDetailOrderInfo(item)"
                  >
                    <div class="d-flex align-center justify-center">
                      <div class="d-flex flex-column">
                        <span class="text-body-1 font-weight-bold">
                          {{ item.shopInfo.name }}/{{ item.order.localOrderId }}
                        </span>
                        <span class="text-body-2">{{ fromNowTimestamp(item.order.checkoutTimestamp) }}</span>
                      </div>
                      <v-spacer />
                      <div class="text-h4">
                        {{ item.order.total | priceDisplay }}
                      </div>
                    </div>
                  </v-card>
                </div>
                <div class="d-flex mt-2">
                  <v-card
                    class="pa-4"
                    elevation="0"
                  >
                    <div class="d-flex flex-column">
                      <div class="text-caption">
                        上次消费
                      </div>
                      <div class="text-body-1">
                        {{ fromNowTimestamp(historyOrder[0].order.checkoutTimestamp) }}
                      </div>
                    </div>
                  </v-card>
                  <v-card
                    class="pa-4 ml-2"
                    elevation="0"
                  >
                    <div class="d-flex flex-column">
                      <div class="text-caption">
                        累计消费
                      </div>
                      <div class="text-body-1">
                        {{ info.totalConsume |priceDisplay }}
                      </div>
                    </div>
                  </v-card>
                </div>
              </template>
              <template v-else>
                暂无消费
              </template>
            </v-tab-item>
            <v-tab-item>
              <div style="height: 50vh; overflow: scroll">
                <v-card
                  v-for="(item,index) in progress"
                  :key="index"
                  class="py-2 px-4 mt-2"
                  elevation="0"
                >
                  <div class="d-flex align-center justify-center">
                    <div class="d-flex flex-column">
                      <span class="text-body-1 font-weight-bold">
                        {{ item.awardInfo.awardDisplayDetails.name }}/{{ item.progress }}
                      </span>
                      <span class="text-body-2">{{ fromNowTimestamp(item.lastUpdateAt) }}</span>
                    </div>
                    <v-spacer />
                    <div class="text-h4">
                      {{ item.status }}
                    </div>
                  </div>
                </v-card>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div style="height: 50vh; overflow: scroll">
                <v-card
                  v-for="(item,index) in allVoucherRecord"
                  :key="index"
                  class="py-2 px-4 mt-2"
                  elevation="0"
                >
                  <div class="d-flex align-center justify-center">
                    <div class="d-flex flex-column">
                      <span class="text-body-1 font-weight-bold">
                        {{ item.voucherInfo.displayInfo.name }}/{{ item.voucherInfo.discountStr }}
                      </span>
                      <span class="text-body-2">{{ fromNowTimestamp(item.createTimestamp) }}</span>
                    </div>
                    <v-spacer />
                  </div>
                </v-card>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
        <v-divider class="my-3" />
        <div class="d-flex flex-wrap">
          <v-chip
            class="ma-1"
            color="grey lighten-1"
          >
            {{ $t('brithDay') }}: {{ info.ageDisplay }}
          </v-chip>
          <v-chip
            class="ma-1"
            color="grey lighten-1"
          >
            {{ $t('Gender') }}: {{ cloudUserDetail?.gender }}
          </v-chip>
        </div>
      </loading-provider>
    </v-card>
    <v-dialog
      v-model="showDetailOrderInfoDialog"
      max-width="800px"
    >
      <detail-order
        :info="detailInfo"
        @close="showDetailOrderInfoDialog = false"
      />
    </v-dialog>
  </div>
</template>

<style scoped>

</style>
